'use strict';

exports.__esModule = true;

var _redux = require('redux');

var _widgetReducers = require('./widget-reducers');

exports.default = (0, _redux.combineReducers)({
    widget: _widgetReducers.widget
});